import NoDataSvg from "../../assets/img/no_data.svg";

export default function NoData({ size = 30, title = "NENHUM REGISTRO LOCALIZADO" }) {
    return (
        <div style={{width: '100%', display:'flex', justifyContent:'center', flexDirection: 'column', gap: 15, opacity: 0.8}}>
            <img alt="No Data" src={NoDataSvg} style={{ height: `${size}vh` }} />
            <h3 style={{textAlign:'center'}}>{title}</h3>
        </div>
    );
}